import { Form, Input, ModalProps, FormProps, Modal, message, Button } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import React, { useEffect } from 'react'
import { getUsersById, updateUsersById } from 'users'
import { UserOutlined, MailOutlined, CloseOutlined } from '@ant-design/icons'

type CreateUserProps = {
  modalProps: ModalProps
  formProps: FormProps
  close: any
  record: any
  refreshData: any
}

export const UserEdit: React.FC<CreateUserProps> = ({ modalProps, formProps, close, record, refreshData }) => {
  const { data: user } = useGetIdentity()
  const { changeUserName } = useUserContext()
  
  useEffect(() => {
    if (modalProps.visible && record) {
      formProps.form?.setFieldsValue({
        displayName: record.displayName,
        email: record.email,
        user_id: record.id
      })
    }
  }, [modalProps.visible, record, formProps.form])

  const success = (msg: string, type: string) => {
    if (type === 'success') {
      message.success(msg)
      close()
    } else message.error(msg)
  }

  return (
    <Modal
      {...modalProps}
      title={null}
      width={480}
      centered
      destroyOnClose={true}
      closable={true}
      closeIcon={
        <div style={{
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          backgroundColor: '#F3F4F6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.2s',
          marginTop: '10px',
          marginRight: '10px'
        }}>
          <CloseOutlined style={{ fontSize: '14px', color: '#6B7280' }} />
        </div>
      }
      onCancel={() => {
        formProps.form?.resetFields()
        close()
      }}
      footer={null}
      bodyStyle={{ padding: '48px 32px 32px 32px', borderRadius: '12px' }}
      maskStyle={{ backdropFilter: 'blur(4px)', backgroundColor: 'rgba(0,0,0,0.45)' }}
      style={{ borderRadius: '12px', overflow: 'hidden' }}
    >
      <div style={{ marginBottom: '32px', textAlign: 'center' }}>
        <div style={{ 
          width: '64px', 
          height: '64px', 
          borderRadius: '16px', 
          backgroundColor: 'rgba(102, 89, 255, 0.1)', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          margin: '0 auto 16px'
        }}>
          <UserOutlined style={{ fontSize: '32px', color: '#6659FF' }} />
        </div>
        <h2 style={{ fontSize: '20px', fontWeight: 700, color: '#111827', margin: 0 }}>Edit Your Profile</h2>
        <p style={{ fontSize: '14px', color: '#6B7280', marginTop: '4px' }}>Make changes to your account settings</p>
      </div>

      <Form
        {...formProps}
        size="large"
        layout="vertical"
        requiredMark={false}
        onFinish={(values) => {
          updateUsersById(values).then((response) => {
            refreshData()
            if (response === 'OK') {
              getUsersById(record?.id).then((resp: any) => {
                changeUserName(resp?.users[0]?.displayName)
              })
              success('Profile updated successfully', 'success')
            } else {
              success('Error updating profile', 'danger')
            }
          })
        }}
      >
        <div style={{ marginBottom: '20px' }}>
          <Form.Item
            label={<span style={{ fontWeight: 600, color: '#374151', fontSize: '14px' }}>Display Name</span>}
            name="displayName"
            initialValue={record?.displayName}
            rules={[{ required: true, message: 'Display name is required' }]}
            style={{ marginBottom: 0 }}
          >
            <Input 
              prefix={<UserOutlined style={{ color: '#9CA3AF', marginRight: '8px' }} />} 
              placeholder="Your full name"
              style={{ 
                height: '48px',
                borderRadius: '10px', 
                border: '1px solid #E5E7EB',
                backgroundColor: '#F9FAFB'
              }}
            />
          </Form.Item>
        </div>
        
        <div style={{ marginBottom: '32px' }}>
          <Form.Item
            label={<span style={{ fontWeight: 600, color: '#374151', fontSize: '14px' }}>Email Address</span>}
            name="email"
            initialValue={record?.email}
            rules={[
              { required: true, message: 'Email is required' },
              { type: 'email', message: 'Invalid email format' }
            ]}
            style={{ marginBottom: 0 }}
          >
            <Input 
              prefix={<MailOutlined style={{ color: '#9CA3AF', marginRight: '8px' }} />} 
              placeholder="Your email address"
              style={{ 
                height: '48px',
                borderRadius: '10px', 
                border: '1px solid #E5E7EB',
                backgroundColor: '#F9FAFB'
              }}
            />
          </Form.Item>
        </div>

        <Form.Item name="user_id" initialValue={record?.id} hidden>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="updated_by" initialValue={user?.id} hidden>
          <Input type="hidden" />
        </Form.Item>

        <div style={{ display: 'flex', gap: '12px' }}>
          <Button 
            onClick={() => {
              formProps.form?.resetFields()
              close()
            }}
            style={{ 
              flex: 1,
              borderRadius: '10px', 
              height: '48px', 
              fontWeight: 600,
              color: '#374151',
              backgroundColor: '#fff',
              border: '1px solid #E5E7EB'
            }}
          >
            Cancel
          </Button>
          <Button 
            type="primary"
            htmlType="submit"
            style={{ 
              flex: 1,
              backgroundColor: '#6659FF', 
              borderColor: '#6659FF',
              borderRadius: '10px',
              height: '48px',
              fontWeight: 600,
              boxShadow: '0 4px 6px -1px rgba(102, 89, 255, 0.2), 0 2px 4px -1px rgba(102, 89, 255, 0.1)'
            }}
          >
            Save Changes
          </Button>
        </div>
      </Form>
    </Modal>
  )
}
